import { render, staticRenderFns } from "./Recommends.vue?vue&type=template&id=44068e83&scoped=true"
import script from "./Recommends.vue?vue&type=script&lang=js"
export * from "./Recommends.vue?vue&type=script&lang=js"
import style0 from "./Recommends.vue?vue&type=style&index=0&id=44068e83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44068e83",
  null
  
)

export default component.exports